import React, { Component } from 'react';
import styled from 'styled-components';

const Label = styled.label`
  display: inline-block;
  // margin: 0 0 10px 0;
  font-weight: 700;
  input {
    margin-right: 7px;
  }
`

class CheckboxInput extends Component {
  render() {
    // let { value } = this.props
    // value = value ? value : ""
    const { label } = this.props
    return (
      <Label>
        <input type="checkbox" {...this.props} />
        {label}
      </Label>
    )
  }
}

export default CheckboxInput